import { Component, Injectable } from '@angular/core';
import { DATASET_TYPES_OBSERVATION_IDS } from '../../../shared/dataset/model/dataset-type.enum';
import { ChooseDatasetModalComponent } from '../modals/choose-dataset-modal/choose-dataset-modal.component';
import { StudyEditorContext } from '../../study-editor.context';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatasetModel } from '../../../shared/dataset/model/dataset.model';
import { ChooseEnvironmentModalComponent } from '../modals/choose-environment-modal/choose-environment-modal.component';
import { StudyInstanceItem } from '../study-instances-table-selector/study-instances-table-selector.component';
import { StudyInstanceService } from '../../../shared/study/service/study-instance.service';
import { CreateGenotypingSamplesModalComponent } from '../modals/create-genotyping-samples-modal/create-genotyping-samples-modal.component';
import { StudyEditorService } from '../../study-editor.service';

@Injectable({
    providedIn: 'root'
})
export class GenotypingSamplesModalService {

    constructor(private studyEditorContext: StudyEditorContext,
                private studyInstanceService: StudyInstanceService,
                private modalService: NgbModal,
                private studyEditorService: StudyEditorService) { }

    createGenotypingSamples() {
        this.showDatasetSelection();
    }

    private showDatasetSelection() {
        const plotDataset = this.studyEditorContext.getPlotDataset();
        let supportedDatasetTypes = [];
        if (this.studyEditorContext.hasGeneratedDesign()) {
            supportedDatasetTypes = [...supportedDatasetTypes, ...DATASET_TYPES_OBSERVATION_IDS];
        }

        const modalRef = this.modalService.open(ChooseDatasetModalComponent as Component, { size: 'sm', backdrop: 'static' });
        modalRef.componentInstance.titleKey = 'study-editor.genotyping-samples.select-dataset.title';
        modalRef.componentInstance.descriptionKey = 'study-editor.genotyping-samples.select-dataset.description';
        modalRef.componentInstance.supportedDatasetTypes = supportedDatasetTypes;
        if (plotDataset) {
            modalRef.componentInstance.selectedDatasetType = plotDataset;
        }

        modalRef.result.then((datasetModel) => {
            this.openSelectEnvironmentToGenerateModal(datasetModel);
        });
    }

    private openSelectEnvironmentToGenerateModal(datasetModel: DatasetModel) {
        this.studyInstanceService.listStudyInstances(this.studyEditorContext.studyId).toPromise().then((instances) => {
            const chooseEnvironmentModal = this.modalService.open(ChooseEnvironmentModalComponent as Component, { size: 'md', backdrop: 'static' });
            chooseEnvironmentModal.componentInstance.studyInstanceItems = instances.filter(item => item.hasExperimentalDesign);
            chooseEnvironmentModal.componentInstance.titleKey = 'study-editor.genotyping-samples.select-environment.title';
            chooseEnvironmentModal.componentInstance.headerKey = 'study-editor.genotyping-samples.select-environment.header';
            chooseEnvironmentModal.componentInstance.descriptionKey = 'study-editor.genotyping-samples.select-environment.description';
            chooseEnvironmentModal.componentInstance.cancelLabelKey = 'back';
            chooseEnvironmentModal.componentInstance.continueLabelKey = 'continue';
            chooseEnvironmentModal.componentInstance.continueBehavior = 'close_immediately';
            chooseEnvironmentModal.result.then((studyInstanceItems: StudyInstanceItem[]) => {
                this.openGenotypingSamplesModal(datasetModel, studyInstanceItems);
            }, () => {
                this.showDatasetSelection();
            });
        });
    };

    private openGenotypingSamplesModal(datasetModel: DatasetModel, studyInstanceItems: StudyInstanceItem[]) {
        const modalRef = this.modalService.open(CreateGenotypingSamplesModalComponent as Component, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.studyId = this.studyEditorContext.studyId;
        modalRef.componentInstance.datasetId = datasetModel.datasetId;
        modalRef.componentInstance.instanceIds = studyInstanceItems.filter(item => item.isChecked).map(item => item.instanceNumber.toString());
        modalRef.result
            .then((res) => {
                this.studyEditorService.triggerRefreshAndWait().then(() => {
                    this.studyEditorService.navigateToSampleListTab(this.studyEditorContext.studyId, res);
                });
            });
    }

}
